<template>
  <el-breadcrumb separator="|" class="classify-bread-crumb">
    <el-breadcrumb-item v-for="(item, index) in value.content" :key="index">
                  <span class="title cursor" @click="change(item)"
                        :class="{'text-primary': item.value === activeItem}">
      {{item.label}}
                  </span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'classfyBreadCrumb',
  props: {
    value: Object,
    activeItem: String
  },
  // created () {
  //   this.activeItem = this.value.content[0].value
  // },
  methods: {
    change (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped lang="less">
  .classify-bread-crumb {
    width: 100%;
    overflow-x: auto;

    /deep/ .el-breadcrumb__item{
      display: flex;
    }
    /deep/ .el-breadcrumb__separator {
      color: #212529;
    }

    .title {
      font-size: 16px;
      color: #212529!important;
      font-weight: bolder;
    }

  }
</style>
